import React, {PureComponent} from 'react';
import AblyService from '../../../utils/ably';
import {PageLoader} from '../../common';
import {store} from '../../../store';
import {AUTH_LOGOUT} from '../../../actions/types';

export default function RealTimeHOC(WrappingComponent) {
  class RealTimeComponent extends PureComponent {
    constructor(props) {
      super(props);
      this.ably = {};
      this.state = {
        ablyStatus: 'offline',
      };
    }
    componentWillMount() {
      if (!AblyService.realtime) {
        this.setState({ablyStatus: 'offline'});
        AblyService.authorize();
      } else {
        this.setState({ablyStatus: 'online'});
      }
      this.ably = AblyService.realtime;
      this.ably.connection.on('connected', () => {
        this.setState({ablyStatus: 'online'});
      });
      // ably v2: the connection state-change listener receives a
      // ConnectionStateChange whose `reason` is an optional ErrorInfo (it may
      // be undefined on a clean disconnect). Read statusCode defensively so a
      // normal disconnect does not throw, while preserving the 401 -> logout
      // detection that backs the auth-expiry handling.
      this.ably.connection.on('disconnected', (stateChange) => {
        const reason = stateChange && stateChange.reason;
        const statusCode = reason && reason.statusCode;
        if (statusCode === 401) {
          return store.dispatch({type: AUTH_LOGOUT});
        }
        return this.setState({ablyStatus: 'disconnected'});
      });
    }
    componentWillUnmount() {
      if (this.ably) {
        this.ably.connection.off();
      }
    }
    render() {
      const {ablyStatus} = this.state;
      switch (ablyStatus) {
        case 'online': {
          return (
            <WrappingComponent
              ably={this.ably}
              {...this.props}
            />
          );
        }
        case 'disconnected': {
          return <div className="error-message">Ably Error</div>; // TODO change to error message;
        }
        default: {
          return <PageLoader/>;
        }
      }
    }
  }
  return RealTimeComponent;
}
